import { useContext } from "react";
import { BsQuote } from "react-icons/bs";
import { Element } from "react-scroll";
import { Autoplay, Keyboard, Mousewheel, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { testimonial } from "../../../constants";
import { ThemeContext } from "../../context";
import {
  JiffyCard,
  JiffyCardContainer,
  JiffyCardName,
  JiffyCardOccupation,
  JiffyCardQuote,
  JiffyCards,
  JiffyContainer,
  JiffyContent,
  JiffyController,
  JiffyImage,
  JiffyTestimonialHeading,
  JiffyTestimonialParagraph,
} from "./Testimonial.elements";
import { RightCustomerContainer } from "../RightCustomers/RightCustomers.elements";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const Testimonials = () => {
  const { rooTheme } = useContext(ThemeContext);

  return (
    <Element id="Testimonial" name="Testimonial">
      <RightCustomerContainer rooTheme={rooTheme}>
        <JiffyContainer>
          <JiffyContent>
            <JiffyTestimonialHeading rooTheme={rooTheme}>
              Testimonials
            </JiffyTestimonialHeading>
            <JiffyTestimonialParagraph rooTheme={rooTheme}>
              Here are something some of our users has to say about us
            </JiffyTestimonialParagraph>
          </JiffyContent>

          <div>
            <div>
              <Swiper
                modules={[
                  Navigation,
                  Pagination,
                  Keyboard,
                  Mousewheel,
                  Autoplay,
                ]}
                mousewheel={{
                  forceToAxis: true,
                }}
                keyboard={true}
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                centeredSlides={true}
                pagination={{ el: ".custom-pagination", clickable: true }}
                breakpoints={{
                  0: { slidesPerView: 1 },

                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                  },
                  1440: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
              >
                <JiffyCards>
                  {testimonial.map((profile, index) => {
                    return (
                      <SwiperSlide key={index} className="swiper-container">
                        <JiffyCard key={index} rooTheme={rooTheme}>
                          <JiffyController>
                            <BsQuote className="text-2xl font-extrabold text-buttondefault" />
                            <JiffyCardQuote rooTheme={rooTheme}>
                              {profile.quote}
                            </JiffyCardQuote>
                            <div className="h-[1px] w-full bg-black mb-5 opacity-10"></div>
                            <JiffyCardContainer>
                              <JiffyImage src={profile.imgsrc} />

                              <div>
                                <JiffyCardName rooTheme={rooTheme}>
                                  {profile.name}
                                </JiffyCardName>
                                <JiffyCardOccupation rooTheme={rooTheme}>
                                  {profile.occupation}
                                </JiffyCardOccupation>
                              </div>
                            </JiffyCardContainer>
                          </JiffyController>
                        </JiffyCard>
                      </SwiperSlide>
                    );
                  })}
                </JiffyCards>
              </Swiper>
              <div className="custom-pagination"></div>
            </div>
          </div>
        </JiffyContainer>
      </RightCustomerContainer>
    </Element>
  );
};
